// src/services/templateAdaptationService.js
export const getFieldConfig = (sectionType, templateType) => {
  const configs = {
    hero: {
      organisation: {
        title: 'Hero Section',
        subtitle: 'Create a powerful first impression for your organisation',
        headingLabel: 'Organisation Name',
        headingPlaceholder: 'Your Organisation Name',
        subHeadingLabel: 'Tagline',
        subHeadingPlaceholder: 'Your mission in one sentence',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Tell visitors about your organisation\'s purpose and impact...',
        enableCTA: true,
        enableSecondaryButton: true,
        enableVideoButton: true,
        enableBackgroundImage: true,
        enableMainImage: true,
        primaryButtonTextPlaceholder: 'Join Us',
        secondaryButtonTextPlaceholder: 'Learn More'
      },
      education: {
        title: 'Course Hero',
        subtitle: 'Introduce your course with impact',
        headingLabel: 'Course Title',
        headingPlaceholder: 'Master Web Development',
        subHeadingLabel: 'Course Subtitle',
        subHeadingPlaceholder: 'Learn modern web technologies from scratch',
        descriptionLabel: 'Course Overview',
        descriptionPlaceholder: 'Describe what students will learn and achieve...',
        enableCTA: true,
        enableSecondaryButton: true,
        enableVideoButton: true,
        enableBackgroundImage: true,
        enableMainImage: true,
        primaryButtonTextPlaceholder: 'Enroll Now',
        secondaryButtonTextPlaceholder: 'Preview Course'
      },
      institution: {
        title: 'Institution Hero',
        subtitle: 'Showcase your academic institution',
        headingLabel: 'Institution Name',
        headingPlaceholder: 'University of Excellence',
        subHeadingLabel: 'Institution Motto',
        subHeadingPlaceholder: 'Inspiring minds, shaping futures',
        descriptionLabel: 'About the Institution',
        descriptionPlaceholder: 'Share your institution\'s academic mission and community...',
        enableCTA: true,
        enableSecondaryButton: true,
        enableVideoButton: true,
        enableBackgroundImage: true,
        enableMainImage: true,
        primaryButtonTextPlaceholder: 'Apply Now',
        secondaryButtonTextPlaceholder: 'Virtual Tour'
      },
      catalog: {
        title: 'Product Hero',
        subtitle: 'Showcase your products and brand',
        headingLabel: 'Brand Name',
        headingPlaceholder: 'Premium Products Co.',
        subHeadingLabel: 'Brand Promise',
        subHeadingPlaceholder: 'Quality products for modern living',
        descriptionLabel: 'Brand Story',
        descriptionPlaceholder: 'Tell customers about your brand and what makes you special...',
        enableCTA: true,
        enableSecondaryButton: true,
        enableVideoButton: false,
        enableBackgroundImage: true,
        enableMainImage: true,
        primaryButtonTextPlaceholder: 'Shop Now',
        secondaryButtonTextPlaceholder: 'View Catalog'
      }
    },

    about: {
      organisation: {
        title: 'About Your Organisation',
        subtitle: 'Tell visitors about your organisation\'s purpose and mission',
        descriptionLabel: 'Organisation Description',
        descriptionPlaceholder: 'Describe your organisation, its purpose, values, and what makes it unique...',
        enableMission: true,
        missionLabel: 'Mission Statement',
        missionPlaceholder: 'What is your organisation\'s mission and purpose?',
        visionLabel: 'Vision Statement', 
        visionPlaceholder: 'What is your organisation\'s vision for the future?',
        enableValues: true,
        valuesLabel: 'Core Values',
        valueItemLabel: 'Value',
        enableHistory: true,
        historyLabel: 'Our History',
        historyPlaceholder: 'Tell the story of how your organisation was founded and evolved...'
      },
      education: {
        title: 'About This Course',
        subtitle: 'Provide course overview and learning objectives',
        descriptionLabel: 'Course Description',
        descriptionPlaceholder: 'Describe what students will learn, prerequisites, and course outcomes...',
        enableMission: true,
        missionLabel: 'Learning Objectives',
        missionPlaceholder: 'What will students achieve by completing this course?',
        visionLabel: 'Course Goals',
        visionPlaceholder: 'What are the long-term goals of this educational program?',
        enableValues: true,
        valuesLabel: 'Key Concepts',
        valueItemLabel: 'Concept',
        enableHistory: false
      },
      institution: {
        title: 'About Our Institution',
        subtitle: 'Share your institution\'s academic mission and values',
        descriptionLabel: 'Institution Overview',
        descriptionPlaceholder: 'Provide an overview of your institution, its academic focus, and community...',
        enableMission: true,
        missionLabel: 'Academic Mission',
        missionPlaceholder: 'What is your institution\'s educational mission?',
        visionLabel: 'Educational Vision',
        visionPlaceholder: 'What is your vision for student success and institutional growth?',
        enableValues: true,
        valuesLabel: 'Educational Values',
        valueItemLabel: 'Value',
        enableHistory: true,
        historyLabel: 'Our Heritage',
        historyPlaceholder: 'Share the history and traditions of your institution...'
      },
      catalog: {
        title: 'About Our Company',
        subtitle: 'Tell customers about your business and what you offer',
        descriptionLabel: 'Company Description',
        descriptionPlaceholder: 'Describe your business, what you do, and what sets you apart...',
        enableMission: true,
        missionLabel: 'Our Mission',
        missionPlaceholder: 'What is your company\'s mission and commitment to customers?',
        visionLabel: 'Our Vision',
        visionPlaceholder: 'What is your vision for the business and industry?',
        enableValues: true,
        valuesLabel: 'Company Values',
        valueItemLabel: 'Value',
        enableHistory: true,
        historyLabel: 'Our Story',
        historyPlaceholder: 'Tell the story of how your business started and grew...'
      }
    },
    
    leadership: {
      organisation: {
        title: 'Leadership Team',
        subtitle: 'Meet the people leading your organisation',
        listLabel: 'Team Members',
        memberLabel: 'Team Member',
        positionLabel: 'Position/Role',
        positionPlaceholder: 'e.g., Executive Director, Board Chair',
        enableSocial: true,
        enableQualifications: true,
        qualificationsLabel: 'Qualifications & Experience',
        enableDepartments: true,
        departmentsLabel: 'Departments',
        departmentLabel: 'Department',
        departmentPlaceholder: 'e.g., Operations, Finance',
        headLabel: 'Department Head'
      },
      education: {
        title: 'Instructors & Staff',
        subtitle: 'Meet your teaching team and support staff',
        listLabel: 'Teaching Team',
        memberLabel: 'Instructor',
        positionLabel: 'Title/Subject',
        positionPlaceholder: 'e.g., Mathematics Instructor, Course Coordinator',
        enableSocial: false,
        enableQualifications: true,
        qualificationsLabel: 'Teaching Credentials',
        enableDepartments: true,
        departmentsLabel: 'Subjects/Departments',
        departmentLabel: 'Subject Area',
        departmentPlaceholder: 'e.g., Mathematics, Science',
        headLabel: 'Lead Instructor'
      },
      institution: {
        title: 'Faculty & Administration',
        subtitle: 'Meet our academic and administrative leadership',
        listLabel: 'Faculty & Staff',
        memberLabel: 'Faculty Member',
        positionLabel: 'Title/Department',
        positionPlaceholder: 'e.g., Professor of Biology, Dean of Students',
        enableSocial: true,
        enableQualifications: true,
        qualificationsLabel: 'Academic Credentials',
        enableDepartments: true,
        departmentsLabel: 'Academic Departments',
        departmentLabel: 'Department',
        departmentPlaceholder: 'e.g., Biology, Engineering',
        headLabel: 'Department Chair'
      },
      catalog: {
        title: 'Our Team',
        subtitle: 'Meet the people behind our products and services',
        listLabel: 'Team Members',
        memberLabel: 'Team Member',
        positionLabel: 'Role',
        positionPlaceholder: 'e.g., Sales Manager, Product Specialist',
        enableSocial: true,
        enableQualifications: false,
        enableDepartments: true,
        departmentsLabel: 'Departments',
        departmentLabel: 'Department',
        departmentPlaceholder: 'e.g., Sales, Customer Service',
        headLabel: 'Manager'
      }
    },

    services: {
      organisation: {
        title: 'Services & Programs',
        subtitle: 'Discover what we offer to our community',
        listLabel: 'Our Services',
        itemLabel: 'Service',
        itemTitleLabel: 'Service Name',
        itemTitlePlaceholder: 'e.g., Community Outreach, Advocacy Program',
        descriptionPlaceholder: 'Describe this service or program and who it helps...',
        enablePricing: false,
        enableDuration: true,
        durationLabel: 'Duration/Schedule',
        durationPlaceholder: 'e.g., Ongoing, 6 months, Weekly meetings',
        enableLevel: false,
        enableCategory: true,
        categoryLabel: 'Category',
        categoryPlaceholder: 'e.g., Community Service, Education',
        enableFeatures: true,
        enableCategories: true,
        categoriesLabel: 'Service Categories'
      },
      education: {
        title: 'Courses & Programs',
        subtitle: 'Explore our educational offerings',
        listLabel: 'Available Courses',
        itemLabel: 'Course',
        itemTitleLabel: 'Course Title',
        itemTitlePlaceholder: 'e.g., Introduction to Mathematics, Advanced Physics',
        descriptionPlaceholder: 'Course overview, learning outcomes, and prerequisites...',
        enablePricing: true,
        enableDuration: true,
        durationLabel: 'Course Duration',
        durationPlaceholder: 'e.g., 12 weeks, 1 semester',
        enableLevel: true,
        levelLabel: 'Difficulty Level',
        levelOptions: [
          { value: 'beginner', label: 'Beginner' },
          { value: 'intermediate', label: 'Intermediate' },
          { value: 'advanced', label: 'Advanced' }
        ],
        enableCategory: true,
        categoryLabel: 'Subject',
        categoryPlaceholder: 'e.g., Mathematics, Science',
        enableFeatures: true,
        enableCategories: true,
        categoriesLabel: 'Subject Areas'
      },
      institution: {
        title: 'Academic Programs',
        subtitle: 'Explore our degree programs and academic offerings',
        listLabel: 'Academic Programs',
        itemLabel: 'Program',
        itemTitleLabel: 'Program Name',
        itemTitlePlaceholder: 'e.g., Bachelor of Science, Master of Arts',
        descriptionPlaceholder: 'Program description, requirements, and career outcomes...',
        enablePricing: true,
        enableDuration: true,
        durationLabel: 'Program Length',
        durationPlaceholder: 'e.g., 4 years, 2 years',
        enableLevel: true,
        levelLabel: 'Degree Level',
        levelOptions: [
          { value: 'certificate', label: 'Certificate' },
          { value: 'diploma', label: 'Diploma' },
          { value: 'bachelor', label: 'Bachelor\'s Degree' },
          { value: 'master', label: 'Master\'s Degree' },
          { value: 'doctoral', label: 'Doctoral Degree' }
        ],
        enableCategory: true,
        categoryLabel: 'Faculty/School',
        categoryPlaceholder: 'e.g., Engineering, Business',
        enableFeatures: true,
        enableCategories: true,
        categoriesLabel: 'Academic Schools'
      },
      catalog: {
        title: 'Products & Services',
        subtitle: 'Browse our complete product catalog',
        listLabel: 'Products',
        itemLabel: 'Product',
        itemTitleLabel: 'Product Name',
        itemTitlePlaceholder: 'e.g., Premium Widget, Professional Service',
        descriptionPlaceholder: 'Product features, benefits, and specifications...',
        enablePricing: true,
        enableDuration: false,
        enableLevel: false,
        enableCategory: true,
        categoryLabel: 'Category',
        categoryPlaceholder: 'e.g., Electronics, Software',
        enableFeatures: true,
        enableCategories: true,
        categoriesLabel: 'Product Categories'
      }
    },

    events: {
      organisation: {
        title: 'Events & Activities',
        subtitle: 'Stay updated with our upcoming events',
        listLabel: 'Upcoming Events',
        itemLabel: 'Event',
        titlePlaceholder: 'e.g., Annual Fundraiser, Community Meeting',
        descriptionPlaceholder: 'Event details, agenda, and what to expect...',
        locationPlaceholder: 'Event venue or address',
        enableRegistration: true,
        enablePricing: true,
        categoryLabel: 'Event Type',
        categoryPlaceholder: 'e.g., Fundraiser, Meeting, Workshop'
      },
      education: {
        title: 'Classes & Workshops',
        subtitle: 'Join our educational sessions and workshops',
        listLabel: 'Scheduled Classes',
        itemLabel: 'Class',
        titlePlaceholder: 'e.g., Advanced Mathematics Workshop, Study Group',
        descriptionPlaceholder: 'Class objectives, materials needed, and preparation...',
        locationPlaceholder: 'Classroom or meeting location',
        enableRegistration: true,
        enablePricing: false,
        categoryLabel: 'Subject',
        categoryPlaceholder: 'e.g., Mathematics, Science'
      },
      institution: {
        title: 'Campus Events',
        subtitle: 'Discover what\'s happening on campus',
        listLabel: 'Campus Events',
        itemLabel: 'Event',
        titlePlaceholder: 'e.g., Graduation Ceremony, Open House',
        descriptionPlaceholder: 'Event information and campus community details...',
        locationPlaceholder: 'Campus location or building',
        enableRegistration: true,
        enablePricing: false,
        categoryLabel: 'Event Category',
        categoryPlaceholder: 'e.g., Academic, Social, Administrative'
      },
      catalog: {
        title: 'Promotions & Events',
        subtitle: 'Don\'t miss our special offers and events',
        listLabel: 'Current Promotions',
        itemLabel: 'Promotion',
        titlePlaceholder: 'e.g., Summer Sale, Product Launch',
        descriptionPlaceholder: 'Promotion details, terms, and conditions...',
        locationPlaceholder: 'Store location or online',
        enableRegistration: false,
        enablePricing: true,
        categoryLabel: 'Promotion Type',
        categoryPlaceholder: 'e.g., Sale, Launch Event'
      }
    },

    news: {
      organisation: {
        title: 'News & Updates',
        subtitle: 'Stay informed about our latest activities',
        listLabel: 'Recent News',
        itemLabel: 'News Article',
        titlePlaceholder: 'e.g., New Program Launch, Community Impact Update',
        summaryPlaceholder: 'Brief summary of the news...',
        contentPlaceholder: 'Full article content and details...',
        authorPlaceholder: 'Article author or spokesperson',
        categoryLabel: 'News Category',
        categoryPlaceholder: 'e.g., Programs, Community, Achievements',
        enableStatus: true
      },
      education: {
        title: 'Course Updates',
        subtitle: 'Latest news about courses and educational content',
        listLabel: 'Course Announcements',
        itemLabel: 'Announcement',
        titlePlaceholder: 'e.g., New Course Available, Schedule Change',
        summaryPlaceholder: 'Quick overview of the update...',
        contentPlaceholder: 'Detailed information about the course update...',
        authorPlaceholder: 'Instructor or administrator',
        categoryLabel: 'Update Type',
        categoryPlaceholder: 'e.g., New Course, Schedule, Assessment',
        enableStatus: true
      },
      institution: {
        title: 'Campus News',
        subtitle: 'Latest news from our academic community',
        listLabel: 'News Articles',
        itemLabel: 'News Article',
        titlePlaceholder: 'e.g., Research Breakthrough, Student Achievement',
        summaryPlaceholder: 'Article summary for preview...',
        contentPlaceholder: 'Full news article content...',
        authorPlaceholder: 'Reporter or communications office',
        categoryLabel: 'News Category',
        categoryPlaceholder: 'e.g., Research, Student Life, Academics',
        enableStatus: true
      },
      catalog: {
        title: 'Company News',
        subtitle: 'Latest updates about our products and business',
        listLabel: 'News & Announcements',
        itemLabel: 'News Item',
        titlePlaceholder: 'e.g., New Product Release, Company Milestone',
        summaryPlaceholder: 'Brief news summary...',
        contentPlaceholder: 'Detailed news content and information...',
        authorPlaceholder: 'PR team or company representative',
        categoryLabel: 'News Type',
        categoryPlaceholder: 'e.g., Product News, Company Updates',
        enableStatus: true
      }
    },

    contact: {
      organisation: {
        title: 'Contact Information',
        subtitle: 'Get in touch with our organisation',
        addressPlaceholder: 'Organisation headquarters address...',
        enableMultipleContacts: true,
        additionalContactsLabel: 'Additional Contact Methods',
        contactLabelPlaceholder: 'e.g., Donations, Volunteer Coordinator',
        enableSocial: true,
        enableHours: true,
        hoursLabel: 'Office Hours'
      },
      education: {
        title: 'Contact & Support',
        subtitle: 'Reach out for course information and support',
        addressPlaceholder: 'Learning center or office address...',
        enableMultipleContacts: true,
        additionalContactsLabel: 'Department Contacts',
        contactLabelPlaceholder: 'e.g., Academic Support, Registration',
        enableSocial: false,
        enableHours: true,
        hoursLabel: 'Support Hours'
      },
      institution: {
        title: 'Contact Our Institution',
        subtitle: 'Connect with our campus community',
        addressPlaceholder: 'Campus address and location...',
        enableMultipleContacts: true,
        additionalContactsLabel: 'Department Contacts',
        contactLabelPlaceholder: 'e.g., Admissions, Financial Aid, Registrar',
        enableSocial: true,
        enableHours: true,
        hoursLabel: 'Campus Hours'
      },
      catalog: {
        title: 'Contact Us',
        subtitle: 'Get in touch for orders and support',
        addressPlaceholder: 'Business address and location...',
        enableMultipleContacts: true,
        additionalContactsLabel: 'Department Contacts',
        contactLabelPlaceholder: 'e.g., Sales, Support, Returns',
        enableSocial: true,
        enableHours: true,
        hoursLabel: 'Business Hours'
      }
    }
  };

  if (sectionType === 'posts') {
    return POSTS_TEMPLATE_CONFIGS[templateType] || POSTS_TEMPLATE_CONFIGS.organisation;
  }

  return configs[sectionType]?.[templateType] || configs[sectionType]?.organisation || {};
};

const POSTS_TEMPLATE_CONFIGS = {
  organisation: {
    title: 'Community Posts',
    subtitle: 'Share updates and engage with your community',
    categories: [
      { value: 'announcement', label: 'Community Announcements', icon: '📢' },
      { value: 'event', label: 'Event Updates', icon: '📅' },
      { value: 'achievement', label: 'Community Achievements', icon: '🏆' },
      { value: 'program', label: 'Program Updates', icon: '📋' },
      { value: 'volunteer', label: 'Volunteer Opportunities', icon: '🤝' }
    ],
    defaultVisibility: 'public',
    enablePriority: true,
    enableTargetAudience: true,
    moderationRequired: false
  },
  
  institution: {
    title: 'Campus News & Updates',
    subtitle: 'Keep your academic community informed',
    categories: [
      { value: 'academic', label: 'Academic News', icon: '🎓' },
      { value: 'research', label: 'Research Updates', icon: '🔬' },
      { value: 'student', label: 'Student Life', icon: '👥' },
      { value: 'administration', label: 'Administrative Updates', icon: '🏛️' },
      { value: 'facilities', label: 'Campus Facilities', icon: '🏢' }
    ],
    defaultVisibility: 'internal',
    enableDepartments: true,
    enableAcademicYear: true,
    moderationRequired: true
  },
  
  business: {
    title: 'Company Communications',
    subtitle: 'Internal and external business updates',
    categories: [
      { value: 'corporate', label: 'Corporate News', icon: '🏢' },
      { value: 'hr', label: 'HR Updates', icon: '👨‍💼' },
      { value: 'product', label: 'Product Announcements', icon: '📦' },
      { value: 'finance', label: 'Financial Updates', icon: '💰' },
      { value: 'culture', label: 'Company Culture', icon: '🎉' }
    ],
    defaultVisibility: 'internal',
    enableConfidentiality: true,
    enableBusinessUnits: true,
    moderationRequired: true
  }
};